import React from 'react';
export function generateMenuItems(config) {
    const { hasBillingAccess, hasMyClientsAccess, hasNFSeModuleEnabled, hasBillingManagementActive, supportMenuItem, IconComponent, ProductStatus, hasAccountPjAccess, hasDigitalAccountingAccess, hasClientPortalViewPermission, hasBenefitAccess, hasCreditoPjAccess, hasLoyaltyProgramAccess, hasTwoOrMoreAccesses, translate, onLoyaltyProgramMenuClick, } = config;
    const menuItems = [];
    if (hasTwoOrMoreAccesses) {
        menuItems.push({
            label: 'Visão geral',
            icon: React.createElement(IconComponent, { name: 'home' }),
            path: '/home',
        });
    }
    if (hasAccountPjAccess) {
        menuItems.push({
            label: translate('products.conta-pj'),
            icon: React.createElement(IconComponent, { name: 'digitalAccount' }),
            path: '/conta-pj',
        });
    }
    if (hasBillingAccess) {
        menuItems.push({
            label: 'Cobranças',
            icon: React.createElement(IconComponent, { name: 'handHoldingDollar' }),
            path: '/cobrancas',
            status: ProductStatus.ACTIVE,
        });
    }
    if (hasNFSeModuleEnabled && hasBillingManagementActive) {
        menuItems.push({
            label: 'Notas fiscais',
            icon: React.createElement(IconComponent, { name: 'fileInvoiceIssued' }),
            path: '/notas-fiscais',
        });
    }
    if (hasBenefitAccess) {
        menuItems.push({
            label: 'Benefícios',
            icon: React.createElement(IconComponent, { name: 'faceSmileWinkl' }),
            path: '/beneficios',
        });
    }
    if (hasAccountPjAccess) {
        menuItems.push({
            label: 'Pagamentos',
            icon: React.createElement(IconComponent, { name: 'fileInvoiceDollar' }),
            path: '/pagamentos',
        });
    }
    if (hasClientPortalViewPermission || hasDigitalAccountingAccess) {
        menuItems.push({
            label: translate('products.contabilidade-digital'),
            icon: React.createElement(IconComponent, { name: 'content' }),
            path: '/contabilidade-digital',
        });
    }
    if (hasLoyaltyProgramAccess && config.domain === 'escritorio') {
        menuItems.push({
            label: translate('products.programa-fidelidade'),
            icon: React.createElement(IconComponent, { name: 'coinsDollar' }),
            path: '/dominio-recompensas',
            ...(onLoyaltyProgramMenuClick ? { onClick: onLoyaltyProgramMenuClick } : {}),
        });
    }
    if (hasCreditoPjAccess && config.domain === 'empresa') {
        menuItems.push({
            label: 'Crédito PJ',
            icon: React.createElement(IconComponent, { name: 'envelopeOpenDollar' }),
            path: '/credito-pj',
        });
    }
    if (hasMyClientsAccess) {
        menuItems.push({
            label: translate('products.my-clients'),
            icon: React.createElement(IconComponent, { name: 'doubleUsers' }),
            path: '/meus-clientes',
        });
    }
    menuItems.push(supportMenuItem);
    return menuItems;
}
